import React from 'react';
import Elevator from 'assets/svg/elevator.svg';
import NewElevator from 'assets/svg/new-elevator.svg';
import Parking from 'assets/svg/parking.svg';
import NewParking from 'assets/svg/new-parking.svg';
import AirConditioner from 'assets/svg/air-condition.svg';
import Grating from 'assets/svg/filters/project-16-bars.svg';
import Safety from 'assets/svg/filters/project-16-saftey-unit.svg';
import NewSafety from 'assets/svg/safety.svg';
import Balcony from 'assets/svg/balcony.svg';
import Wheel from 'assets/svg/wheelchair-il.svg';
import Storage from 'assets/svg/filters/project-16-warehouse.svg';
import NewStorage from 'assets/svg/storage.svg';
import People from 'assets/svg/new-people.svg';
import Paint from 'assets/svg/paint.svg';
import NewDoorman from 'assets/svg/new-doorman.svg';
import CheckCircle from 'assets/svg/new-check-circle.svg';
import SubDivisible from 'assets/svg/squares-four.svg';
import Garden from 'assets/svg/garden.svg';
import { Amenity } from 'utils/entities';
import { ExtraAmenityType } from './types';
import GardenAreas from 'assets/svg/garden-areas.svg';
import AirDirections from 'assets/svg/air-directions.svg';
import BalconyAreas from 'assets/svg/balcony-areas.svg';
import WarehouseAreas from 'assets/svg/warehouse-areas.svg';
import UnitPetsAllowed from 'assets/svg/pets.svg';
import ForPartners from 'assets/svg/for-partners.svg';
import Shower from 'assets/svg/shower.svg';
import Toilet from 'assets/svg/toilet.svg';
import Mamak from 'assets/svg/filters/secure_1.svg';
import Miklat from 'assets/svg/filters/secure_2.svg';


export const checkListAmenities: Amenity[] = [
  Amenity.Parking,
  Amenity.SecureRoom,
  Amenity.Mamak,
  Amenity.Miklat,
  Amenity.Elevator,
  Amenity.Storage,
  Amenity.AirConditioner,
  Amenity.Accessible,
  Amenity.Grating,
  Amenity.Balcony,
  Amenity.Garden,
  Amenity.SunBoiler,
  Amenity.Pool,
];

export const featuredAmenities: Array<{
  icon: React.ReactNode,
  key: Amenity,
}> = [
  {
    icon: <Elevator />,
    key: Amenity.Elevator,
  },
  {
    icon: <AirConditioner />,
    key: Amenity.AirConditioner,
  },
  {
    icon: <Parking />,
    key: Amenity.Parking,
  },
  {
    icon: <Balcony />,
    key: Amenity.Balcony,
  },
  {
    icon: <Garden />,
    key: Amenity.Garden,
  },
  {
    icon: <Grating />,
    key: Amenity.Grating,
  },
  {
    icon: <Safety />,
    key: Amenity.SecureRoom,
  },
  {
    icon: <Storage />,
    key: Amenity.Storage,
  },
  {
    icon: <Wheel />,
    key: Amenity.Accessible,
  },
];

export const commercialAmenities: Set<string> = new Set([
  Amenity.SecureRoom,
  Amenity.Mamak,
  Amenity.Miklat,
  Amenity.Doorman,
  Amenity.Storage,
  Amenity.SubDivisible,
]);

export const amenityToIconMap: Partial<Record<Amenity, JSX.Element>> = {
  [Amenity.Parking]: <NewParking />,
  [Amenity.SecureRoom]: <NewSafety />,
  [Amenity.Mamak]: <Mamak />,
  [Amenity.Miklat]: <Miklat />,
  [Amenity.Balcony]: <BalconyAreas />,
  [Amenity.Elevator]: <NewElevator />,
  [Amenity.Storage]: <NewStorage />,
  [Amenity.Doorman]: <NewDoorman />,
  [Amenity.SubDivisible]: <SubDivisible />,
  [Amenity.UnitPetsAllowed]: <UnitPetsAllowed />,
  [Amenity.ForRoommates]: <ForPartners />,
};

export const extraAmenityToIconMap: Record<ExtraAmenityType, JSX.Element> = {
  [ExtraAmenityType.People]: <People />,
  [ExtraAmenityType.GeneralCondition]: <Paint />,
  [ExtraAmenityType.QualityClass]: <CheckCircle />,
  [ExtraAmenityType.Parking]: <NewParking />,
  [ExtraAmenityType.AirDirection]: <AirDirections />,
  [ExtraAmenityType.BalconyAreas]: <BalconyAreas />,
  [ExtraAmenityType.GardenAreas]: <GardenAreas />,
  [ExtraAmenityType.WarehouseAreas]: <WarehouseAreas />,
  [ExtraAmenityType.Bathroom]: <Shower />,
  [ExtraAmenityType.Toilet]: <Toilet />,
};

export const extraAmenityVisibleIfMultiple: ExtraAmenityType[] = [
  ExtraAmenityType.Bathroom,
  ExtraAmenityType.Toilet,
  ExtraAmenityType.AirDirection,
];
